import { useState, type ReactNode } from "react";
import Button from "@mui/material/Button";

type ExpandableListProps<T> = {
  items: T[];
  renderItems: (items: T[]) => ReactNode;
};

export default function ExpandableList<T>({ items, renderItems }: ExpandableListProps<T>) {
  const [showAll, setShowAll] = useState(false);

  return (
    <>
      {renderItems(showAll ? items : items.slice(0, 3))}
      {items.length > 3 && (
        <Button onClick={() => setShowAll(!showAll)} sx={{ margin: "0 auto" }}>
          {showAll ? "Weniger Anzeigen" : "Alle Anzeigen"}
        </Button>
      )}
    </>
  );
}
